<template>
  <div>
    <template v-for="item in menu">
      <el-menu-item
        v-if="!item.children && !hideItem(item)"
        :key="getPath(item)"
        :index="getPath(item)"
        :disabled="disableItem(item)"
      >
        <span :id="item.id" slot="title">{{ $t(item.meta.title) }} </span>
      </el-menu-item>

      <el-submenu
        v-if="item.children"
        :key="getPath(item)"
        :index="getPath(item)"
        :disabled="disableItem(item)"
      >
        <template slot="title">
          <span :id="item.id">
            {{ $t(item.meta.title) }}
          </span>
        </template>

        <sidebar-item :menu="item.children" :parent="getPath(item)" />
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    menu: {
      type: Array,
      default() {
        return [];
      },
    },
    parent: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    hideItem(item) {
      if (
        (!this.$store.state.user.support.vpn_client || this.$store.state.page.type == "orbi") &&
        item.path.includes("vpnClient")
      ) {
        return true;
      }
      if (
        (!this.$store.state.user.support.ipmac || this.$store.state.page.type == "orbi") &&
        item.path.includes("ipmac")
      ) {
        return true;
      }
      if (this.$store.state.page.type != "orbi" && item.path.includes("addSatellite")) {
        return true;
      }
      if (
        this.$store.state.page.type == "orbi" &&
        (item.path.includes("wizard") || item.path.includes("wps") || item.path.includes("led"))
      ) {
        return true;
      }

      if (item.hide_mode && item.hide_mode.includes(this.$store.state.user.device_mode)) {
        return true;
      }
      return false;
    },
    disableItem(item) {
      if (this.$store.state.user.wps_active == "inactive" && item.path.includes("wps")) {
        return true;
      } else if (
        this.$store.state.user.menu_disabled ||
        (item.off_mode && item.off_mode.includes(this.$store.state.user.device_mode))
      ) {
        return true;
      }
      return false;
    },
    getPath(item) {
      let path = this.parent;
      if (path !== "") {
        path += "/";
      }
      return path + item.path;
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.left-menu {
  .el-menu--inline {
    padding-top: 5px;
    padding-bottom: 8px;
  }
  .el-menu-item.is-disabled:hover,
  .el-menu-item.is-disabled,
  .el-submenu.is-disabled .el-menu-item,
  .el-submenu.is-disabled .el-submenu__title {
    opacity: 1;
    color: $leftMenuDisabledColor;
  }
  .el-submenu.is-opened .el-menu.el-menu--inline .el-menu-item.is-disabled {
    opacity: 1;
    color: $leftMenuDisabledColor;
  }
  .empty-icon {
    width: 24px;
    height: 24px;
    display: inline-table;
  }
  .el-menu-item {
    min-height: $leftMenuItemHeight;
  }
  .el-menu-item,
  .el-submenu .el-menu-item,
  .el-submenu__title {
    padding-left: $leftMenuItemPaddingLeft !important;
    padding-top: 6px;
    padding-bottom: 5px;
    padding-right: $leftMenuItemPaddingLeft;
    line-height: 16px;
    height: auto;
    border-bottom: 1px solid $leftMenuBottomBorderColor;
    white-space: normal;
    color: $leftMenuFontColor;
    font-weight: 500;
  }
  .el-submenu__title {
    padding-right: 18px;
  }
  .el-menu-item:focus,
  .el-menu-item:hover,
  .el-submenu__title:focus,
  .el-submenu__title:hover {
    color: inherit;
    background: inherit;
  }
  .el-menu-item:hover {
    padding-bottom: 4px;
    border-bottom: 2px solid $leftMenuBottomBorderColor;
  }
  .el-menu-item.is-active.is-disabled,
  .el-menu-item:hover.is-active.is-disabled,
  .el-menu-item.is-active,
  .el-menu-item:hover.is-active {
    color: $leftMenuActiveColor;
    background: $leftMenuActiveBgColor !important;
    border-color: $leftMenuActiveBorderColor;
  }

  .el-submenu.is-active .el-submenu__title,
  .el-submenu:hover.is-active .el-submenu__title {
    border-color: $leftMenuBottomBorderColor;
  }

  .el-submenu__icon-arrow {
    transform: none;
    top: calc(50% - 7px);
    right: 0;
  }
  .el-submenu__icon-arrow::before {
    background: url(~images/iconSprite2x.png) no-repeat;
    background-position: -265px -175px;
    content: " ";
    transform: scale(0.5);
    width: 25px;
    height: 25px;
    display: inline-block;
  }
  .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
    transform: none;
  }
  .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow::before {
    background-position: -360px -175px;
  }
  .el-submenu .el-menu-item,
  .el-submenu .el-menu-item:hover {
    padding-bottom: 5px;
    border-bottom: 1px solid #fff;
  }
  .el-menu.el-menu--inline {
    border-bottom: 1px solid $leftMenuBottomBorderColor;
    padding-left: $leftMenuPaddingLeft;
  }
  .el-menu.el-menu--inline .el-menu-item {
    padding-left: 15px !important;
    min-width: auto;
  }
  // .el-menu.el-menu--inline .el-menu-item.is-active,
  // .el-menu.el-menu--inline .el-menu-item:hover.is-active {
  //   border-color: $leftMenuBottomBorderColor;
  // }
  .el-submenu .el-menu-item.is-active.is-disabled,
  .el-submenu .el-menu-item:hover.is-active.is-disabled,
  .el-submenu .el-menu-item.is-active,
  .el-submenu .el-menu-item:hover.is-active {
    border-color: $leftMenuSubMenuBottomBorderColor;
  }
}
.orbi.gui-2-1 {
  .left-menu {
    .el-menu-item:hover {
      border-bottom-width: 1px;
    }
    .el-menu-item:not(.is-active):hover span {
      border-bottom: 1px solid $leftMenuFontColor;
    }
    .el-menu-item.is-active:hover span,
    .el-menu-item.is-active span {
      border-bottom: 1px solid $leftMenuActiveColor;
      font-weight: bold;
    }
    .el-submenu .el-menu-item span {
      width: 100%;
      display: inline-block;
    }
    .el-submenu .el-menu-item:hover {
      padding-top: 7px;
      border-bottom-width: 0;
    }
    .el-submenu .el-menu-item.is-active:hover {
      padding-top: 6px;
    }
  }
}
</style>
